import { Box, Center, Flex, Spinner } from "@chakra-ui/react";
import { DataTable, EmptyState } from "@pufflig/prompt-studio-ui";

interface TablePreviewPanelProps {
  tableName?: string;
  data?: any[];
  isLoading?: boolean;
}

export const TablePreviewPanel = ({ data = [], isLoading }: TablePreviewPanelProps) => {
  const isEmpty = data.length === 0;
  return (
    <Flex flex="1" overflow="auto">
      {isLoading ? (
        <Center width="100%" height="100%">
          <Spinner />
        </Center>
      ) : isEmpty ? (
        <EmptyState title="Empty Table" showBackground={false} />
      ) : (
        <Box width="100%">
          <DataTable isReadOnly data={data} />
        </Box>
      )}
    </Flex>
  );
};
